/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext } from 'react';

import { Constraints } from '../config/constraints';

const NodeConstraintsContext = createContext();

export const useNodeConstraints = () => {
  const context = useContext(NodeConstraintsContext);
  if (!context) {
    throw new Error('useNodeConstraints must be used within a NodeConstraintsProvider');
  }
  return context;
};

export const NodeConstraintsProvider = ({ children }) => {
  const canConnectNodes = (sourceType, targetType) => {
    const sourceConstraints = Constraints[sourceType];
    const targetConstraints = Constraints[targetType];

    if (!sourceConstraints || !targetConstraints) {
      return false;
    }

    // If source has acceptedChildNodes, target must be in that list
    if (sourceConstraints.acceptedChildNodes.length > 0) {
      if (!sourceConstraints.acceptedChildNodes.includes(targetType)) {
        return false;
      }
    }

    // If target has acceptedParentNodes, source must be in that list
    if (targetConstraints.acceptedParentNodes.length > 0) {
      if (!targetConstraints.acceptedParentNodes.includes(sourceType)) {
        return false;
      }
    }

    return true;
  };

  return (
    <NodeConstraintsContext.Provider
      value={{
        canConnectNodes,
        constraints: Constraints,
      }}
    >
      {children}
    </NodeConstraintsContext.Provider>
  );
};
